import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';
import ScrollToTop from '@components/ScrollToTop.tsx';

const Header = lazy(() => import('@components/web/header/Header'));
const Footer = lazy(() => import('@components/web/footer/Footer'));

const PublicLayout = () => {
  return (
    <>
      <ScrollToTop />

      <Suspense fallback="Loading...">
        <Header />
      </Suspense>
      <main role="main">
        <Outlet />
      </main>
      <Suspense fallback="Loading...">
        <Footer />
      </Suspense>
    </>
  );
};

export default PublicLayout;
